import React from 'react';

class OverlayBody extends React.Component {
  render() {
    return <div className="overlay-body">{this.props.children}</div>;
  }
}

export default OverlayBody;
